import { call, put, select } from 'redux-saga/effects';
import { getLegalTerms as getLegalTermsAda } from '@bitComponents/adabyron/cqv2';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* getLegalTerms(params) {
  const {
    reduxUpdate,
    cqId,
    normalizeHttpErrors,
  } = params;
  try {
    const { successUpdate } = reduxUpdate;

    const context = yield select(contextStore);
    const response = yield call(getLegalTermsAda, { cqId }, context);
    yield put(successUpdate(response));
    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GET_LEGAL_TERMS, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
